export const themesQuery = `
  query themes($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: ThemeOrder, $where: ThemeWhereInput) {
    themes(
      after: $after
      before: $before
      first: $first
      last: $last
      orderBy: $orderBy
      where: $where
    ) {
      edges {
        cursor
        node {
          ...ThemeSelect
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
  fragment ThemeSelect on Theme {
    createdAt
    id
    isGlobal
    isPublished
    name
    thumbnail
    updatedAt
  }
`;

export const themePageMutation = `
  mutation themePageCreate($input: CreateThemePageInput!) {
    themePageCreate(input: $input) {
      ...ThemePageSelect
    }
  }
  fragment ThemePageSelect on ThemePage {
    id
    name
    description
    type
    default
    isGlobal
    isMobile
    status
    sectionPosition
    splitPercentage
    themeStyle {
      id
      data
    }
    handle
    createdAt
    updatedAt
  }
`;

export const shopPlatformConnectMutation = `
  mutation ShopPlatformConnect($input: CreateShopPlatformInput!) {
    shopPlatformConnect(input: $input)
  }
`;
